import { useStoreFavicon } from '../../hooks/useStoreFavicon.js';
import { useStoreTitle } from '../../hooks/useStoreTitle.js';
import { useStoreManifest } from '../../hooks/useStoreManifest.js';

/** Renders nothing — it only keeps the document head in sync with the store's settings. */
export default function StoreHead() {
    useStoreFavicon();
    useStoreTitle();
    useStoreManifest();
    return null;
}
